function Footer() {
    return (
        <div>
            <footer className="main-footer">
                <strong>Copyright © 2025 <a href="https://ecogen.ma/">Ecogen</a>.</strong>
                Tous droits réservés.
                <div className="float-right d-none d-sm-inline-block">
                    <b>Version</b> 1.0.0
                </div>
            </footer>

        </div>
    );
}

export default Footer;


